<template>
    <div class="defect-manage-con">
        <div class="defect-search-con">
            <el-form class="leader-style-form" :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="缺陷来源">
                    <el-select v-model="searchForm.defect_source">
                        <el-option
                            v-for="item in defectSource"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="缺陷单号">
                    <el-input maxlength="50" v-model="searchForm.defect_no"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现人">
                    <el-input maxlength="50" v-model="searchForm.founder"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现日期">
                    <el-date-picker
                        v-model="searchForm.found_time"
                        type="date"
                        placeholder="选择日期"
                        :default-value="timeNow"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="缺陷类型">
                    <el-select v-model="searchForm.defect_state">
                        <el-option
                            v-for="item in defectStates"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button style="float: right" @click="getDefectList()" type="warning">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-table :data="tableData" border class="leader-style-table">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="缺陷单号" property="defect_no" align="center"></el-table-column>
                <el-table-column label="缺陷设备名称" property="tree_name" align="center"></el-table-column>
                <el-table-column label="缺陷性质" property="defect_level_name" align="center"></el-table-column>
                <el-table-column label="缺陷来源" property="defect_source_name" align="center"></el-table-column>
                <el-table-column label="缺陷状态" property="dual_method_name" align="center"></el-table-column>
                <el-table-column label="发现人" property="founder" align="center"></el-table-column>
                <el-table-column label="发现人电话" property="founder_phone" align="center"></el-table-column>
                <el-table-column label="提交时间" property="found_time" align="center"></el-table-column>
                <el-table-column label="消缺完成时间" property="solve_time_end" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="arrangeDefectChange(scope.row)"
                            type="text"
                            class="button-modify"
                            v-if="scope.row.dual_method == '10'"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="arrangeDefectShow(scope.row)"
                            type="text"
                            class="button-custom"
                        >
                            <i class="iconfont iconsearch"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <AddDefentDialog
            :defentDialogVisible.sync="defentDialogVisible"
            :defect_id.sync="defect_id"
            :lookLook.sync="lookLook"
            @updateBeginData="updateBeginData"
            class="leader-dialog"
        ></AddDefentDialog>
        <DefentArrangeDialog
            :defentArrDialogVisible.sync="defentArrDialogVisible"
            :defect_id.sync="defect_id"
            class="leader-dialog"
            @updateBeginData="updateBeginData"
        ></DefentArrangeDialog>
    </div>
</template>
<script>
import AddDefentDialog from './components/add_defent_dialog';
import DefentArrangeDialog from './components/defent_arrange';
import * as api from '../api/index';
export default {
    components: { AddDefentDialog, DefentArrangeDialog },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchForm: {
                defect_source: '', //缺陷来源
                defect_no: '', //缺陷单号
                founder: '', //缺陷发现人
                found_time: '', //缺陷发现日期
                defect_state: '', //缺陷类型
            },
            defectSource: [],
            defectStates: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            defentDialogVisible: false,
            defentArrDialogVisible: false,
            defect_id: '', //需要传递的参数id
            lookLook: false,
        };
    },
    mounted() {
        this.getDefectSource();
        this.getDefectState();
        this.getDefectList();
    },
    methods: {
        //获取缺陷来源
        getDefectSource() {
            api.getCodelistByKind({
                code_kind: 'defect_source',
            }).then((res) => {
                if (res) {
                    this.defectSource = res.bus_json[0].codelists;
                }
            });
        },
        //获取缺陷类型
        getDefectState() {
            api.getCodelistByKind({
                code_kind: 'defect_state',
            }).then((res) => {
                if (res) {
                    this.defectStates = res.bus_json[0].codelists;
                }
            });
        },
        //获取缺陷列表
        getDefectList() {
            api.getDefectList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                defect_source: this.searchForm.defect_source,
                defect_no: this.searchForm.defect_no,
                founder: this.searchForm.founder,
                found_time: this.searchForm.found_time,
                defect_state: this.searchForm.defect_state,
            }).then((res) => {
                if (res) {
                    this.tableData = res.bus_json.items;
                    this.pageNum = res.bus_json.pageNum;
                    this.pageSize = res.bus_json.pageSize;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getDefectList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getDefectList();
        },
        //弹窗保存更新
        updateBeginData() {
            this.getDefectList();
        },
        arrangeDefectChange(row) {
            this.defentDialogVisible = true;
            this.defect_id = row.defect_id;
            this.lookLook = false;
        },
        arrangeDefectShow(row) {
            this.defentArrDialogVisible = true;
            this.defect_id = row.defect_id;
            this.lookLook = true;
        },
    },
};
</script>
<style lang="scss">
.defect-manage-con {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        height: 700px;
    }
    .defect-table-con {
        padding: 0 30px;
    }
}
</style>
